import React, { useState, useEffect } from "react";
import {
  Avatar,
  Button,
  CssBaseline,
  Paper,
  Box,
  Grid,
  Typography,
  MenuItem,
  Select,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import { fetchJsonDynamic } from "../../data/DynamicServiceNew/jsondynamicservice";
import { companyManagementUrl } from "../../config";
import { MCBSwitchCallApi } from "../../data/userData";
import { jwtDecode } from "jwt-decode";
import Laptop2 from "../../Assets/Images/laptop2.jpg";

const defaultTheme = createTheme();

export default function McbSwitch({ onLogin }) {
  const [companyData, setCompanyData] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [branchData, setBranchData] = useState([]);
  const [roleData, setRoleData] = useState([]);

  const [selectedCompany, setSelectedCompany] = useState("");
  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedBranch, setSelectedBranch] = useState("");
  const [selectedRole, setSelectedRole] = useState("");

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // useEffect(() => {
  //   const fetchCompanies = async () => {
  //     const response = await fetchJsonDynamic(
  //       "companies",
  //       null,
  //       null,
  //       companyManagementUrl.uri
  //     );
  //     setCompanyData(JSON.parse(response.results) || []);
  //   };
  //   fetchCompanies();
  // }, []);
  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const response = await fetchJsonDynamic(
          "companies",
          null,
          null,
          companyManagementUrl.uri
        );

        let companies = [];
        if (response?.results) {
          try {
            companies = JSON.parse(response.results) || [];
          } catch (e) {
            console.error("Error parsing company data:", e);
          }
        }

        // Filter active companies and sort by most recent (highest Id first)
        const activeCompanies = Array.isArray(companies)
          ? companies
              .filter((c) => c?.IsActive)
              .sort((a, b) => (b?.Id || 0) - (a?.Id || 0))
          : [];

        setCompanyData(activeCompanies);
      } catch (error) {
        console.error("Error fetching companies:", error);
      }
    };

    fetchCompanies();
  }, []);

  const handleCompanyChange = async (event) => {
    const companyId = event.target.value;
    setSelectedCompany(companyId);
    setSelectedRegion("");
    setBranchData([]);
    setRoleData([]);

    if (!companyId) return;

    try {
      setLoading(true);
      const response = await fetchJsonDynamic(
        "allRegionsByColumnValues",
        "regionModel",
        { companyId: parseInt(companyId) },
        companyManagementUrl.uri
      );
      if (response?.results) {
        try {
          setRegionData(JSON.parse(response.results) || []);
        } catch (e) {
          setRegionData([]);
        }
      } else {
        setRegionData([]);
      }
    } catch (error) {
      console.error("Error fetching regions:", error);
      setRegionData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleRegionChange = async (event) => {
    const regionId = event.target.value;
    setSelectedRegion(regionId);
    setBranchData([]);
    if (!regionId) return;

    try {
      setLoading(true);
      const response = await fetchJsonDynamic(
        "allBranchesByColumnValues",
        "branchModel",
        { companyId: parseInt(selectedCompany), regionId: parseInt(regionId) },
        companyManagementUrl.uri
      );
      if (response?.results) {
        try {
          setBranchData(JSON.parse(response.results) || []);
        } catch (e) {
          setBranchData([]);
        }
      } else {
        setBranchData([]);
      }
    } catch (error) {
      console.error("Error fetching branches:", error);
      setBranchData([]);
    } finally {
      setLoading(false);
    }
  };

  async function saveDataToLocalStorage(response) {
    const token = response.data.token;
    localStorage.setItem("token", JSON.stringify(token));
    localStorage.setItem(
      "tokenExpiration",
      new Date().getTime() + 5 * 60 * 60 * 1000
    );
    localStorage.setItem("filePath", response.data.companyLogoPath || "");
    localStorage.setItem("rights", JSON.stringify(response.data.rights));

    const decodedToken = jwtDecode(token);
    localStorage.setItem("decodedToken", JSON.stringify(decodedToken));
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      const response = await MCBSwitchCallApi(
        selectedCompany,
        selectedRegion,
        selectedBranch
      );
      if (response.status === 200) {
        localStorage.clear();
        saveDataToLocalStorage(response);
        navigate("/super-admin-dashboard");
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <PulseLoader size={15} color={"#3f51b5"} />
        </Box>
      )}
      <Grid
        container
        component="main"
        sx={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundImage: `url(${Laptop2})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <CssBaseline />
        <Grid
          item
          xs={12}
          sm={8}
          md={5}
          component={Paper}
          elevation={6}
          square
          alignItems="center"
          justifyContent="center"
          sx={{
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            borderRadius: "16px",
            padding: 2,
          }}
        >
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Change Company
            </Typography>
            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
              {/* Company Dropdown */}
              <Select
                fullWidth
                variant="outlined"
                value={selectedCompany}
                onChange={handleCompanyChange}
                displayEmpty
              >
                <MenuItem value="" disabled>
                  Select Company
                </MenuItem>
                {companyData.map((company) => (
                  <MenuItem key={company.Id} value={company.Id}>
                    {company.CompanyName}
                  </MenuItem>
                ))}
              </Select>

              {/* Region Dropdown */}
              {selectedCompany && (
                <Select
                  fullWidth
                  variant="outlined"
                  value={selectedRegion}
                  onChange={handleRegionChange} // Updated here
                  displayEmpty
                  sx={{ mt: 2 }}
                >
                  <MenuItem value="" disabled>
                    Select Region
                  </MenuItem>
                  {regionData.map((region) => (
                    <MenuItem key={region.Id} value={region.Id}>
                      {region.Name}
                    </MenuItem>
                  ))}
                </Select>
              )}

              {/* Branch Dropdown */}
              {selectedRegion && (
                <Select
                  fullWidth
                  variant="outlined"
                  value={selectedBranch}
                  onChange={(e) => setSelectedBranch(e.target.value)}
                  displayEmpty
                  sx={{ mt: 2 }}
                >
                  <MenuItem value="" disabled>
                    Select Branch
                  </MenuItem>
                  {branchData.map((branch) => (
                    <MenuItem key={branch.Id} value={branch.Id}>
                      {branch.Name}
                    </MenuItem>
                  ))}
                </Select>
              )}

              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                disabled={loading}
              >
                Proceed
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}
